import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const ElementSettingsTickerDesign = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  let variant = contextData.objects.variant;
  let element = builder.selected().object;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name={`Ticker`} open={true}>

        <VariantBuilderSetting
          object={element}
          label="Container Width"
          setting_name="[options][ticker-container-width-style]"
          setting_type="dropdown"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-container-width-style"] || "full"}
          options={[
            { value: "full", text: "100%" },
            { value: "custom", text: "Custom" },
          ]}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Container Width"
          setting_name="[options][ticker-container-width-value]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-container-width-value"] || undefined}
          condition={element.options["ticker-container-width-style"] === "custom"}
          placeholder="100%"
          min={0}
          max={2560}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Container Width"
          setting_name="[options][ticker-container-width-style-mobile]"
          setting_type="dropdown"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-container-width-style-mobile"] || "full"}
          options={[
            { value: "full", text: "100%" },
            { value: "custom", text: "Custom" },
          ]}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Container Width"
          setting_name="[options][ticker-container-width-value-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["ticker-container-width-value-mobile"] || undefined
          }
          condition={
            element.options["ticker-container-width-style-mobile"] === "custom"
          }
          placeholder={element.options["ticker-container-width-value"] || "100%"}
          min={0}
          max={2560}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Background Color"
          setting_name="[options][ticker-background-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-background-color"] || undefined}
          placeholder={
            variant.options["ticker-background-color"] || "transparent"
          }
          show_reset={true}
          gradient={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Border Style"
          setting_name="[options][ticker-border-style]"
          setting_type="border_style"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["ticker-border-style"] ||
            variant.options["ticker-border-style"] ||
            "none"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Border Color"
          setting_name="[options][ticker-border-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-border-color"] || undefined}
          placeholder={variant.options["ticker-border-color"] || "#000"}
          condition={
            (element.options["ticker-border-style"] ||
              variant.options["ticker-border-style"]) &&
            (element.options["ticker-border-style"] ||
              variant.options["ticker-border-style"]) !== "none"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Border Width"
          setting_name="[options][ticker-border-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-border-width"] || undefined}
          placeholder={variant.options["ticker-border-width"] || "1"}
          condition={
            (element.options["ticker-border-style"] ||
              variant.options["ticker-border-style"]) &&
            (element.options["ticker-border-style"] ||
              variant.options["ticker-border-style"]) !== "none"
          }
          min={0}
          max={20}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Corner Radius"
          setting_name="[options][ticker-border-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="elements"
          object_id={element.id}
          value={
            element.options["ticker-border-radius"] ||
            variant.options["ticker-border-radius"] ||
            "cf-not-rounded"
          }
          show_reset={true}
        />

        {(element.options["ticker-border-radius"] === "custom" ||
          (!element.options["ticker-border-radius"] &&
            variant.options["ticker-border-radius"] === "custom")) && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][ticker-border-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={element}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="elements"
                    object_id={element.id}
                    value={
                      element.options[`ticker-border-radius-${side}`] != null &&
                      element.options[`ticker-border-radius-${side}`] !== ""
                        ? element.options[`ticker-border-radius-${side}`]
                        : undefined
                    }
                    min={0}
                    note={
                      side
                        .split("-")
                        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                        .join(" ")
                    }
                    col="3"
                    placeholder={
                      variant.options[`ticker-border-radius-${side}`] != null
                        ? String(variant.options[`ticker-border-radius-${side}`])
                        : "0"
                    }
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={element}
          label="Gap Between Images"
          setting_name="[options][ticker-image-gap]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-image-gap"] || undefined}
          placeholder={variant.options["ticker-image-gap"] || "20"}
          min={0}
          max={200}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Gap Between Images"
          setting_name="[options][ticker-image-gap-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-image-gap-mobile"] || undefined}
          placeholder={
            element.options["ticker-image-gap"] ||
            variant.options["ticker-image-gap"] ||
            "20"
          }
          min={0}
          max={200}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Max Image Height"
          setting_name="[options][ticker-max-image-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-max-image-height"] || undefined}
          placeholder={variant.options["ticker-max-image-height"] || "120"}
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Max Image Height"
          setting_name="[options][ticker-max-image-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-max-image-height-mobile"] || undefined}
          placeholder={
            element.options["ticker-max-image-height"] ||
            variant.options["ticker-max-image-height"] ||
            "120"
          }
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Max Image Width"
          setting_name="[options][ticker-max-image-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-max-image-width"] || undefined}
          placeholder={variant.options["ticker-max-image-width"] || "300"}
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Max Image Width"
          setting_name="[options][ticker-max-image-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-max-image-width-mobile"] || undefined}
          placeholder={
            element.options["ticker-max-image-width"] ||
            variant.options["ticker-max-image-width"] ||
            "300"
          }
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Fade Edges"
          setting_name="[options][ticker-fade-edges]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={element.options["ticker-fade-edges"]}
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default ElementSettingsTickerDesign;
